import React from 'react'
import {http} from '../../utils'
import {initDriveApp} from '../../modules/drive'
import {DriveRoot} from '../../modules/drive/app/DriveRoot'
import {OrganizationManage} from '../../modules/drive/pages/OrganizationManage'

class DrivePermission extends React.Component {
  componentDidMount() {
    initDriveApp({
      request: http,
      getToken: () => localStorage.getItem('token'),
      theme: () => localStorage.getItem('theme')
    })
  }

  render() {
    return <DriveRoot>
      <OrganizationManage/>
    </DriveRoot>
  }
}

export default DrivePermission